var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue, Prop } from 'vue-property-decorator';
import StreetName from '@/modules/search/components/filterPanels/LocalizationPanel/StreetName.vue';
import { connect } from '@/overmind';
let StreetNameContainer = class StreetNameContainer extends Vue {
    setInputStreetName(streetNameFilter) {
        // @ts-ignore TS2349: property inexistent
        this.actions.setInputFilters(streetNameFilter);
        // @ts-ignore TS2349: property inexistent
        this.actionsSearch.searches.buildPotentialResults();
    }
};
__decorate([
    Prop({ default: () => { } })
], StreetNameContainer.prototype, "filter", void 0);
StreetNameContainer = __decorate([
    Component(connect(({ state: { filters: state }, actions }) => ({
        selected: state.totalSelected.localization.address,
        actions: actions.filters,
        actionsSearch: actions.search,
        stateInputFilters: state.stateInputFilters['no_logradouro'],
    }), {
        components: {
            StreetName,
        },
    }))
], StreetNameContainer);
export default StreetNameContainer;
